import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  select: {
    height: 62,
    maxWidth: 500,
    display: 'inline-block'
  },
  menuContainer: {
    minWidth: 230,
    maxWidth: 300,
    top: '60%'
  },
  indicators: {
    transform: 'translateY(-10px)'
  }
})

export default useStyles
